import React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { Table, Thead, Tbody, Tr, LinkTr, Th, Td } from '../../../components/Table/Fake';
import { CustomerOrGap } from '../types';
import { getCustomerEmail, getCustomerName, getCustomerPhoneNumber, getCustomerType } from '../../customerHelpers';
import { DateTime } from '../../../components/Formatters';
import { isCustomer } from '../helpers';
import { ListGap } from '../../../components/Paging';
import { getListKey } from '../../../helpers/paging';

interface RowProps extends WithTranslation {
    row: CustomerOrGap;
    accountId: string;
    fillGap: (id: string) => void;
}

const Row = (
    {
        row,
        accountId,
        fillGap,
        t,
    }: RowProps
) => {
    if (isCustomer(row)) {
        return (
            <LinkTr
                key={row.id}
                to={`/${accountId}/customers/${encodeURIComponent(row.customer_id)}`}
                className="stop-borders-before-edges"
            >
                <Td className="edge" />
                <Td>{getCustomerName(row)}</Td>
                <Td>{getCustomerPhoneNumber(row)}</Td>
                <Td>{getCustomerEmail(row)}</Td>
                <Td>{t(getCustomerType(row))}</Td>
                <Td>
                    <DateTime isoString={row.updated_at || ''} />
                </Td>
                <Td className="edge" />
            </LinkTr>
        );
    }
    return <ListGap fillGap={fillGap} gap={row} label={t('customers.customers.load_gap')} />;
};

const TranslatedRow = withTranslation()(Row);

export interface CustomerTableProps extends WithTranslation {
    customers: CustomerOrGap[];
    accountId: string;
    fillGap: (id: string) => void;
}

const CustomerTable = (
    {
        customers,
        accountId,
        fillGap,
        t,
    }: CustomerTableProps
) => {
    return (
        <Table className="no-wrap">
            <Thead>
                <Tr>
                    <Th className="edge" />
                    <Th>{t('customers.fields.name')}</Th>
                    <Th>{t('customers.fields.phone')}</Th>
                    <Th>{t('customers.fields.email')}</Th>
                    <Th>{t('customers.fields.type')}</Th>
                    <Th>{t('customers.fields.last_updated')}</Th>
                    <Th className="edge" />
                </Tr>
            </Thead>
            {customers.length > 0 && (
                <Tbody>
                    {customers.map((customer) => (
                        <TranslatedRow
                            key={getListKey(customer)}
                            row={customer}
                            accountId={accountId}
                            fillGap={fillGap}
                        />
                    ))}
                </Tbody>
            )}
        </Table>
    );
};

export default withTranslation()(CustomerTable);
